/*
 * Dispatches a toast message.
 */
(function() {
    'use strict';

    angular.module('paysera.toast').factory('toastDispatcher', toastDispatcherFactory);

    toastDispatcherFactory.$inject = ['ngToast'];

    function toastDispatcherFactory(ngToast) {
        return {
            success: success,
            error: error
        };

        /**
         * @param {!String} string to display
         * @param {String} [toastClass = 'warning']
         */
        function dispatch(string, toastClass) {
            ngToast.create({
                content: string,
                timeout: 60000,
                dismissButton: true,
                className: toastClass ? toastClass : 'warning'
            });
        }

        function success(string) {
            dispatch(string, 'success');
        }

        function error(string) {
            dispatch(string, 'danger');
        }
    }
})();
